var _defs, _sodipodiNamedview;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestForQuoteConfirmationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 4000,
    height: 2666.6667,
    viewBox: "0 0 4000 2666.6667",
    sodipodiDocname: "_error.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 19261.6,11286.7 c 0,-231.4 187.6,-418.9 418.9,-418.9 h 6430.1 c 231.4,0 418.9,187.5 418.9,418.9 v 3800.4 h -7267.9 v -3800.4",
    id: "path54"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,2666.6667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 30000 V 20000 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19351.4,2843.4 -5852.9,11 5652.1,14.3 237.2,-3.7 c -12.1,-7.3 -24.3,-14.5 -36.4,-21.6 m -8123.6,15.3 -1193.5,2.2 c -477.32,455 -846.85,1011.9 -1040.32,1644 -122.08,398.8 -159.71,823.8 -120.03,1241.3 324.42,-1043 1067.55,-2003.9 2120.75,-2732.6 75.5,-52.3 153.9,-104.4 233.1,-154.9 m 24.9,21.9 c -81.6,51.9 -162.2,105.4 -239.9,159.1 -1071.49,741.5 -1820.11,1724 -2130.11,2787.9 118.99,996 677.81,1937.1 1579.11,2365.1 559.2,265.4 1166.3,321.1 1788.6,321.1 224.8,0 451.8,-7.3 679,-14.5 227.3,-7.3 454.9,-14.6 681.5,-14.6 236,0 470.9,7.9 702.6,31.9 7.3,0.8 14.6,1.6 21.9,2.3 l 130.1,-276.5 48,-102.4 c 104.6,-222.2 320,-354.1 539.1,-354.1 79,0 158.6,17.2 233.6,53.4 368.3,178.1 577.9,558.9 570.8,962.3 88.1,-14.9 176.4,-27.4 265.1,-37.3 223.2,-24.9 450.8,-33 678.6,-33 222.4,0 445.1,7.8 664,15.4 215.6,7.5 433.1,15.1 650.1,15.1 597.4,0 1190.7,-57.4 1727.7,-332 1202.7,-614.8 1835.4,-2330.6 1410.4,-3824.7 -8.8,-30.9 -18,-61.5 -27.7,-91.8 -340.2,-480.5 -772.6,-903.3 -1250.1,-1258 90.7,173.3 148,384.5 151.7,634.1 v 0 0 c 3.8,248.9 -45.9,536 -169.1,861.8 l -600.2,1473.1 -1608.1,-597.2 571.3,-1300.6 1.2,-3.4 0.1,-0.1 -2862,-320.2 -549.3,177.5 c -78.5,25.3 -159.4,37.8 -239.7,37.8 -174.1,0 -345.7,-58.4 -485.4,-170 -479,-382.6 -1257.8,-1087.8 -1056,-1144.5 27.6,-7.8 55.8,-13.7 84.7,-18.1 l -1961.6,-4.9 m 2244.9,5.7 c 262,31.9 548.1,133.8 814.1,200.6 75.3,18.9 152.2,28.3 228.7,28.3 147,0 293,-34.6 425.8,-102.6 l 238.2,-122 -1706.8,-4.3 m 7786.5,1712.2 c 427.7,1507.5 -212.2,3238.6 -1427,3859.7 -542.8,277.5 -1140.1,335.5 -1741.1,335.5 -217.8,0 -436.1,-7.6 -652.4,-15.1 -218.4,-7.7 -440.5,-15.4 -662.3,-15.4 -227,0 -453.7,8.1 -675.6,32.7 -90.3,10.1 -180.1,22.9 -269.7,38.2 -0.6,12.4 -1.3,24.7 -2.3,37.1 541.2,173.7 1077.1,374.8 1623.4,529.4 510.1,144.3 1053.8,243.9 1585.4,243.9 568.5,0 1123,-113.9 1607.4,-408.6 1077.9,-655.8 1508.5,-2099.4 1207.6,-3324.8 -115.9,-472.2 -322.5,-911.7 -593.4,-1312.6",
    style: {
      fill: "#f9f9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11243.5,2848.7 -4,2.5 c -3.9,2.5 -7.8,5 -11.7,7.5 l 2270.7,-4.3 -2255,-5.7 m 8407.5,21.2 c 13.6,10.3 27,21 40.2,32 l 317.6,0.8 c 655.9,523.9 1024.8,1010.6 1216.4,1610.6 19.9,28.2 39.6,56.6 58.9,85.2 -0.2,-0.7 -0.4,-1.4 -0.6,-2.1 -185.1,-651 -561.7,-1166 -1259.2,-1722.1 l -4.4,-3.4 h -5.5 l -363.4,-1 M 8873.95,5746.2 c -32.04,103 -60.02,206.9 -83.79,311.4 -311.02,1367.2 183.75,2832 1176.42,3482.9 437.02,286.7 960.42,430.1 1564.62,430.1 465.3,0 978.5,-85 1537.4,-255.2 104.6,-31.9 209.3,-65.8 313.7,-101 7.7,-13.9 15.5,-27.8 23.3,-41.6 -115.3,39.3 -230.9,77 -346.3,112.1 -555.8,169.3 -1065.9,253.9 -1527.9,253.9 -598.1,0 -1115.6,-141.7 -1547.36,-424.9 -981.95,-643.9 -1471,-2094.6 -1162.83,-3449.3 18.07,-79.4 38.58,-158.4 61.48,-237 -3.25,-27.1 -6.15,-54.2 -8.74,-81.4",
    style: {
      fill: "#bdbeff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13498.5,2854.4 -2270.7,4.3 c -79.2,50.5 -157.6,102.6 -233.1,154.9 -1053.2,728.7 -1796.33,1689.6 -2120.75,2732.6 2.59,27.2 5.49,54.3 8.74,81.4 310,-1063.9 1058.62,-2046.4 2130.11,-2787.9 77.7,-53.7 158.3,-107.2 239.9,-159.1 l 1961.6,4.9 c 42.2,-6.3 85.7,-9.2 130.3,-9.2 49.8,0 100.9,3.6 153,10 l 1706.8,4.3 38,-19.5 3720.7,0.5 133.6,-2.1 53.9,-0.8 -5652.1,-14.3 m 7726.7,1658.9 c 9.7,30.3 18.9,60.9 27.7,91.8 425,1494.1 -207.7,3209.9 -1410.4,3824.7 -537,274.6 -1130.3,332 -1727.7,332 -217,0 -434.5,-7.6 -650.1,-15.1 -218.9,-7.6 -441.6,-15.4 -664,-15.4 -227.8,0 -455.4,8.1 -678.6,33 -88.7,9.9 -177,22.4 -265.1,37.3 -0.1,10.8 -0.5,21.7 -1,32.5 89.6,-15.3 179.4,-28.1 269.7,-38.2 221.9,-24.6 448.6,-32.7 675.6,-32.7 221.8,0 443.9,7.7 662.3,15.4 216.3,7.5 434.6,15.1 652.4,15.1 601,0 1198.3,-58 1741.1,-335.5 1214.8,-621.1 1854.7,-2352.2 1427,-3859.7 -19.3,-28.6 -39,-57 -58.9,-85.2",
    style: {
      fill: "#bbbbff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23290.4,4393.7 c -204,0 -370,-149.2 -370,-332.7 0,-183.4 166,-332.6 370,-332.6 204.1,0 370.1,149.2 370.1,332.6 0,183.5 -166,332.7 -370.1,332.7 z m 0,-863 c -313,0 -567.7,237.9 -567.7,530.3 0,292.5 254.7,530.4 567.7,530.4 313.1,0 567.8,-237.9 567.8,-530.4 0,-292.4 -254.7,-530.3 -567.8,-530.3",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23090.3,2874.2 h -1242.4 l -212.4,2155.6 h 1667.2 l -212.4,-2155.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21867.1,2895.4 h 1204 l 208.2,2113.2 h -1620.4 z m 1242.5,-42.5 h -1281 l -216.5,2198.2 h 1714 l -216.5,-2198.2",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22874.2,3053.3 H 22064 l -138.5,1351.4 h 1087.2 l -138.5,-1351.4",
    style: {
      fill: "#ebebff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3355.92,15563.5 h -230.28 v 42.5 h 230.28 z m 460.53,0 h -230.28 v 42.5 h 230.28 z m 460.52,0 H 4046.7 v 42.5 h 230.27 z m 460.53,0 h -230.25 v 42.5 h 230.25 z m 460.53,0 h -230.26 v 42.5 h 230.26 z m 460.52,0 H 5428.3 v 42.5 h 230.25 z m 460.55,0 h -230.27 v 42.5 h 230.27 z m 460.53,0 h -230.27 v 42.5 h 230.27 z m 460.53,0 h -230.28 v 42.5 h 230.28 z m 455.17,-10.1 c -30.51,6.7 -61.95,10.1 -93.49,10.1 h -131.41 v 42.5 h 131.41 c 34.59,0 69.12,-3.7 102.59,-11.1 z m -4792.95,-87.5 -26.87,32.9 c 62.52,51 137.4,85.5 216.54,99.7 l 7.5,-41.8 c -72.05,-12.9 -140.23,-44.3 -197.17,-90.8 z m 5108.46,-190.5 c -24.59,68.9 -66.78,131 -121.95,179.7 l 28.08,31.8 c 60.57,-53.4 106.86,-121.6 133.87,-197.2 z M 2542.5,15072.9 h -42.46 v 56.4 c 0,61.4 11.48,121.1 34.16,177.5 l 39.41,-15.8 c -20.64,-51.4 -31.11,-105.8 -31.11,-161.7 z m 5336,-247.8 h -42.46 v 230.2 h 42.46 z m -5336,-212.8 h -42.46 v 230.3 h 42.46 z m 5336,-247.8 h -42.46 v 230.3 h 42.46 z m -5336,-212.7 h -42.46 v 230.3 h 42.46 z m 5336,-247.8 h -42.46 v 230.3 h 42.46 z m -5336,-212.7 h -42.46 v 230.2 h 42.46 z m 5336,-247.8 h -42.46 v 230.2 h 42.46 z m -5336,-212.8 h -42.46 v 230.3 h 42.46 z m 5336,-247.8 h -42.46 v 230.3 h 42.46 z m -5336,-212.7 h -42.46 v 230.3 h 42.46 z m 5336,-247.8 h -42.46 v 230.3 h 42.46 z m -5336,-212.7 h -42.46 v 230.2 h 42.46 z m 5336,-247.8 h -42.46 v 230.3 h 42.46 z M 2506.39,11846 c -4.24,25.7 -6.37,52 -6.35,78.1 v 155.3 h 42.46 v -155.3 c -0.02,-23.8 1.93,-47.7 5.8,-71.2 z m 5257.46,-232 -32.27,27.6 c 47.89,55.9 80.96,123.3 95.63,194.9 l 41.6,-8.5 c -16.1,-78.7 -52.4,-152.7 -104.96,-214 z m -4970.82,-129.9 c -74.14,31 -139.85,80.8 -190,144 l 33.28,26.4 c 45.7,-57.6 105.55,-103 173.08,-131.2 z m 464.04,-36.7 H 3026.8 v 42.5 h 230.27 z m 460.53,0 h -230.28 v 42.5 h 230.28 z m 460.53,0 h -230.28 v 42.5 h 230.28 z m 460.52,0 h -230.27 v 42.5 h 230.27 z m 460.53,0 h -230.25 v 42.5 h 230.25 z m 460.53,0 h -230.26 v 42.5 h 230.26 z m 460.54,0 h -230.27 v 42.5 h 230.27 z m 460.53,0 h -230.27 v 42.5 h 230.27 z m 460.53,0 h -230.27 v 42.5 h 230.27 z m 460.53,0 h -230.28 v 42.5 h 230.28 c 52.24,0 103.3,9.2 151.75,27.3 l 14.85,-39.8 c -53.21,-19.9 -109.26,-30 -166.6,-30",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8793.95,10390.9 H 3863.86 c -280.23,0 -507.4,227.2 -507.4,507.4 v 3571 c 0,280.2 227.17,507.4 507.4,507.4 h 4930.09 c 280.23,0 507.4,-227.2 507.4,-507.4 v -3571 c 0,-280.2 -227.17,-507.4 -507.4,-507.4",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4460.37,10833 h -580.16 v 2782.3 h 580.16 V 10833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5539.68,10833 h -580.16 v 2292.7 h 580.16 V 10833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6618.98,10833 h -580.16 v 1864.4 h 580.16 V 10833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7698.3,10833 h -580.17 v 1562.4 H 7698.3 V 10833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8777.6,10833 h -580.15 v 671.5 H 8777.6 V 10833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7768.06,14095.1 H 4889.75 v 249.4 h 2878.31 v -249.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14428.4,15832.5 c -300.2,-139 -699.7,-362.6 -623.7,-760 74.6,-389.9 545.1,-319.6 819.8,-226.4 203.5,69.1 400,161.8 581,277.9 117.5,75.3 282.8,205.5 242.7,366.9 -34.5,138.6 -195.3,179.1 -318.9,153.7 -179.3,-36.8 -384,-146 -524.4,-261.1 -127.5,-104.5 -226.8,-267.2 -201.8,-437.8 22.8,-156 151.6,-267.2 294.8,-316.1 178.6,-61 420.8,-48.5 600.4,6 109.1,33.1 209.9,131.9 138.6,250.1 -84.5,139.8 -259.9,106 -381.5,44.4 -164.2,-83.1 -358.5,-191.7 -439.6,-365.9 -61.7,-132.3 -51.9,-296.4 68,-392.2 117.5,-93.9 287,-94.2 429.3,-83.4 117.8,9 310.2,33.6 328.9,182.2 18.8,149.8 -165.4,217.9 -282.5,173.7 -181.3,-68.5 -294.9,-292.1 -349.9,-465.3 -64.9,-204.5 -63.8,-423.4 -0.7,-628 8.1,-26 49.1,-14.9 41,11.3 -82.1,266.2 -53.6,558.7 86.9,800.5 67.3,115.9 200,299.1 358.4,247.8 84.6,-27.4 144.6,-127.5 69.6,-202.9 -52.7,-53 -141.5,-65.9 -212.3,-73.5 -102.7,-10.9 -213,-15.3 -314,10.6 -174.1,44.8 -260.7,202.3 -195.9,374.2 52.9,140.2 182.4,228.2 305.7,301.8 117.2,69.9 350.9,216.3 451.9,43.2 113,-193.8 -254.7,-214.4 -355.7,-222 -148.3,-11.2 -305.3,-5.9 -435.1,75.8 -137.3,86.4 -198.7,235.7 -148.8,392.2 50.2,157.4 180.9,262.3 320.5,339.4 108.9,60.2 236.6,130.4 359.5,154.1 86.6,16.7 196,3 247.6,-79.2 61.8,-98.4 -11.9,-205.9 -83.2,-273 -199.7,-188.1 -501.4,-306.9 -759.4,-386.3 -268.8,-82.7 -709.8,-100.5 -705.9,295.1 3.3,342.1 341.7,511.2 610.1,635.5 24.8,11.5 3.2,48.1 -21.4,36.7",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11343.1,13829.4 c 68.8,-144.8 131.4,-291.7 192.4,-439.3 l 89.1,-222.1 85.5,-223.5 -127.6,37.6 214.2,168 c 71.5,55.9 144.4,109.9 216.6,164.9 l 87.2,66.5 40.3,-100.9 c 29,-72.6 55.9,-146.1 84,-219.1 27.8,-73.1 53.6,-147 80.4,-220.5 25.3,-74.2 51.7,-147.8 75.5,-222.6 24.6,-74.4 47.7,-149.5 69.2,-225.1 l -61.5,-25.2 c -37.6,69.1 -73.8,138.8 -108.4,209.1 -35.4,70 -68.2,141.1 -102.1,211.7 -32.3,71.3 -65.8,142 -97.2,213.7 -31.1,71.7 -63.4,143 -93.6,215.1 l 127.5,-34.3 c -71.6,-55.7 -142.4,-112.5 -214.6,-167.4 l -217.2,-164.1 -92.2,-69.7 -35.3,107.2 -75,227.2 -71.3,228.5 c -46,152.9 -90.3,306.3 -128.5,462 l 62.6,22.3",
    style: {
      fill: "#ffa121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17398.9,13361.1 c -38.1,-155.7 -82.4,-309.1 -128.5,-462 l -71.2,-228.5 -75,-227.2 -35.4,-107.2 -92.1,69.7 -217.2,164.1 c -72.2,54.9 -143,111.7 -214.6,167.4 l 127.5,34.3 c -30.2,-72.1 -62.5,-143.4 -93.6,-215.1 -31.4,-71.7 -64.9,-142.4 -97.2,-213.7 -33.9,-70.6 -66.7,-141.7 -102.2,-211.7 -34.5,-70.3 -70.7,-140 -108.4,-209.1 l -61.4,25.2 c 21.5,75.6 44.5,150.7 69.2,225.1 23.8,74.8 50.2,148.4 75.5,222.6 26.8,73.5 52.6,147.4 80.4,220.5 28,73 54.9,146.5 84,219.1 l 40.3,100.9 87.2,-66.5 c 72.2,-55 145.1,-109 216.6,-164.9 l 214.2,-168 -127.6,-37.6 85.5,223.5 89.1,222.1 c 60.9,147.6 123.6,294.5 192.4,439.3 l 62.5,-22.3",
    style: {
      fill: "#ffa121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52",
    clipPath: "url(#clipPath56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 19261.6,11286.7 c 0,-231.4 187.6,-418.9 418.9,-418.9 h 6430.1 c 231.4,0 418.9,187.5 418.9,418.9 v 3800.4 h -7267.9 v -3800.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26110.6,10889 h -6430.1 c -219.2,0 -397.6,178.4 -397.6,397.7 v 2932 c 277.2,-22.9 535.2,-231.1 604.8,-502.4 36.9,11.4 75.4,16.9 113.9,16.9 115.6,0 231.8,-49.6 307.8,-137.2 101.3,-116.9 125.7,-294.7 59.5,-434.5 308.9,-48.7 512.6,-431.7 380.3,-715.1 61.6,16.4 125.2,24.4 188.9,24.4 153.3,0 306.8,-46.4 432.6,-134.1 178.1,-124.2 297.5,-329.2 317.8,-545.4 81.3,283.4 365.1,494.3 659.2,494.3 8.5,0 17,-0.2 25.5,-0.5 303.1,-12.7 582,-251.5 641.2,-549 232.7,353.8 561,592.4 932.7,726.4 21.3,-22.4 42.2,-45.3 62.9,-69 l 62.3,91.8 c 9.8,-18.5 19.3,-37.5 28.6,-56.9 l 85.3,104.7 c 175.5,40.9 357.8,61 541.8,61 638.1,0 1298.4,-240.3 1780.3,-680.1 v -627.3 c 0,-219.3 -178.4,-397.7 -397.7,-397.7",
    style: {
      fill: "#e3e3ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18458.4,12837.2 c 217.1,162.1 452,309.9 715.3,373.9 263.2,64 560.5,33.6 773.8,-133.5 213.2,-167.1 312.5,-486.6 183.4,-724.8 183.6,16.5 372.6,-82.5 463.7,-242.7 91.1,-160.2 79.6,-373.2 -28.4,-522.6 185.8,93.1 412.9,99.1 603.3,16.1 190.5,-83 340.7,-253.5 399,-452.9 265.1,222.4 715,167.8 919.2,-111.6 440.3,419 1113.2,650.1 1671.6,409.9 323.8,-139.3 571.5,-418.4 739.2,-728.5 167.7,-310.1 264,-652.9 358.9,-992.4 l -5037.6,-455.6 -2107.9,675.6 346.5,2889.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23712.5,14183 c -149.6,62.4 -304.4,70 -432.1,32.5 -79.9,99.7 -202.5,163.7 -340.2,163.7 -240.8,0 -436.1,-195.3 -436.1,-436.1 0,-62.7 13.5,-122.2 37.3,-176 -84.9,-57.6 -140.7,-154.9 -140.7,-265.2 0,-154.7 109.7,-283.8 255.6,-313.6 -2.6,-19.1 -4.3,-38.5 -4.3,-58.3 0,-240.8 195.2,-436 436,-436 206.3,0 378.6,143.3 424,335.6 45.9,-25.4 98.7,-40 154.8,-40 176.8,0 320.1,143.3 320.1,320.1 0,40.8 -7.9,79.6 -21.8,115.4 45.3,36.8 81.1,82.7 103.7,137.1 92.6,222.3 -66.9,500.3 -356.3,620.8",
    style: {
      fill: "#fff2e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21927.7,14419.6 c -75.4,31.3 -153.3,35.2 -217.6,16.3 -40.2,50.2 -102,82.4 -171.3,82.4 -121.3,0 -219.6,-98.3 -219.6,-219.6 0,-31.5 6.8,-61.5 18.8,-88.6 -42.8,-29 -70.9,-78 -70.9,-133.5 0,-77.9 55.3,-142.9 128.7,-157.9 -1.3,-9.6 -2.1,-19.4 -2.1,-29.3 0,-121.3 98.3,-219.6 219.5,-219.6 103.9,0 190.6,72.1 213.5,169 23.1,-12.8 49.7,-20.2 78,-20.2 89,0 161.1,72.2 161.1,161.2 0,20.5 -3.9,40.1 -10.9,58.1 22.7,18.5 40.8,41.7 52.2,69.1 46.6,111.9 -33.7,251.9 -179.4,312.6",
    style: {
      fill: "#fff2e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20654.5,14550 c 11.2,-40 5.4,-83.8 -27.8,-124.8 -78,-96.6 -216.1,-53.6 -250.8,55.4 -13.6,42.5 -19.9,89.2 -5.8,131.5 50,149.9 249.6,62.5 284.4,-62.1",
    style: {
      fill: "#d1d1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21958.4,12890.3 c 7.1,-25.4 3.4,-53.2 -17.6,-79.3 -49.6,-61.3 -137.3,-34 -159.3,35.2 -8.6,27 -12.7,56.7 -3.7,83.6 31.8,95.1 158.5,39.6 180.6,-39.5",
    style: {
      fill: "#d1d1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24990.3,14079.5 c 7.1,-25.3 3.4,-53.2 -17.7,-79.2 -49.5,-61.4 -137.2,-34.1 -159.3,35.1 -8.6,27.1 -12.6,56.7 -3.6,83.6 31.7,95.1 158.5,39.7 180.6,-39.5",
    style: {
      fill: "#d1d1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 19282.9,15065.9 v -3779.2 c 0,-219.3 178.4,-397.7 397.6,-397.7 h 6430.1 c 219.3,0 397.7,178.4 397.7,397.7 v 3779.2 h -7225.4 m 6827.7,-4219.3 h -6430.1 c -242.6,0 -440.1,197.4 -440.1,440.1 v 3821.6 h 7310.4 v -3821.6 c 0,-242.7 -197.5,-440.1 -440.2,-440.1",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26110.6,16722.7 h -6430.1 c -231.3,0 -418.9,-187.6 -418.9,-418.9 v -1216.7 h 7267.9 v 1216.7 c 0,231.3 -187.5,418.9 -418.9,418.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19282.9,15108.3 h 7225.4 v 1195.5 c 0,219.2 -178.4,397.6 -397.7,397.6 h -6430.1 c -219.2,0 -397.6,-178.4 -397.6,-397.6 z m 7267.9,-42.4 h -7310.4 v 1237.9 c 0,242.7 197.5,440.1 440.1,440.1 h 6430.1 c 242.7,0 440.2,-197.4 440.2,-440.1 v -1237.9",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20552.4,15904.9 c 0,-168.1 -136.3,-304.4 -304.4,-304.4 -168.2,0 -304.5,136.3 -304.5,304.4 0,168.1 136.3,304.4 304.5,304.4 168.1,0 304.4,-136.3 304.4,-304.4",
    style: {
      fill: "#d1d1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24700.9,15635.9 h -3384 c -148.5,0 -269,120.4 -269,269 0,148.5 120.5,269 269,269 h 3384 c 148.6,0 269,-120.5 269,-269 0,-148.6 -120.4,-269 -269,-269",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21317,16152.7 c -136.7,0 -247.8,-111.2 -247.8,-247.8 0,-136.6 111.1,-247.8 247.8,-247.8 h 3383.9 c 136.6,0 247.7,111.2 247.7,247.8 0,136.6 -111.1,247.8 -247.7,247.8 z m 3383.9,-538.1 H 21317 c -160.1,0 -290.3,130.2 -290.3,290.3 0,160 130.2,290.2 290.3,290.2 h 3383.9 c 160,0 290.2,-130.2 290.2,-290.2 0,-160.1 -130.2,-290.3 -290.2,-290.3",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24488.5,13099.3 c 0,0 -610,574.1 -1220.1,586.1 l 442.6,-299.1 -825.4,155.6 765.6,-382.8 -897.1,-59.8 c 480.6,-85.2 905.3,-305.9 1255.9,-705.8 l 478.5,705.8",
    style: {
      fill: "#ffa121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24087.3,12507.5 287,423.4 c 39.5,-54 61.6,-91.1 61.6,-91.1 l -249.7,-306.7 c -33.3,-7.8 -66.1,-16.3 -98.9,-25.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24100.9,12428.4 c -9.3,19.4 -18.8,38.4 -28.6,56.9 l 15,22.2 c 32.8,9.3 65.6,17.8 98.9,25.6 l -85.3,-104.7",
    style: {
      fill: "#f4f4ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24072.3,12485.3 c -137.6,259 -326.6,424.7 -554.9,518.6 l 482,-46.1 -361.2,320.1 419.2,-178.7 -199.9,235.4 c 227.2,-46.2 422,-273.9 516.8,-403.7 l -287,-423.4 -15,-22.2",
    style: {
      fill: "#ffd9a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26692.6,11771.3 c -326.2,570.9 -123,1326.4 -436.9,1520.2 l -623.1,-771.6 1060,-748.6",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26255.7,13291.5 -80.6,8.6 c -85.9,9.3 -171.6,-18.7 -235.5,-76.8 l -526.8,-478.9 219.8,-224.5 623.1,771.6",
    style: {
      fill: "#c5c5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25770.5,10629.4 c -626.7,198.7 -1322.6,-159 -1578.1,107.1 l 623.1,771.6 955,-878.7",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24192.4,10736.5 -25.4,77 c -27.1,82 -17.8,171.7 25.5,246.4 l 357.2,615.8 265.8,-167.6 -623.1,-771.6",
    style: {
      fill: "#c5c5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27340,10301.4 -226.7,636.1 -442.9,-548.5 z",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24227.8,12142.7 c 457.2,-977.7 1299,-1741.9 2442.8,-1753.4 l 442.7,548.2 c -252,1115.7 -1176.3,1777.8 -2228.4,2018.9 l -657.1,-813.7",
    style: {
      fill: "#c5c5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24884.9,12956.4 -242.9,358.1 -815.6,-1010 401.4,-161.8 657.1,813.7",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23989.8,13006.9 v 0 c 32,39.6 90,45.8 129.6,13.8 l 830.9,-671 c 39.7,-32 45.8,-90.1 13.9,-129.7 -32,-39.6 -90.1,-45.8 -129.7,-13.8 l -830.9,671 c -39.6,32 -45.8,90.1 -13.8,129.7",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26002.5,10884.6 c -166.2,134.2 -192.1,377.7 -57.9,543.8 134.2,166.2 377.7,192.1 543.9,58 166.1,-134.2 192.1,-377.7 57.9,-543.9 -134.2,-166.2 -377.7,-192.1 -543.9,-57.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26097,11001.6 c -101.5,82 -117.3,230.8 -35.3,332.3 82,101.5 230.7,117.4 332.2,35.4 101.5,-82 117.4,-230.8 35.4,-332.3 -82,-101.5 -230.7,-117.3 -332.3,-35.4",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26342.3,11176.5 c -18.5,15 -21.4,42.2 -6.4,60.8 15,18.5 42.2,21.4 60.7,6.4 18.6,-15 21.5,-42.2 6.5,-60.8 -15,-18.5 -42.2,-21.4 -60.8,-6.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16280.1,8973 -1476,89.6 -1925.9,-508.9 c -675.4,-178.3 -1223.8,-671.1 -1472.7,-1323.5 l -1203.3,-3151.3 2364.6,2095.3 651.3,-3299 4417.6,14.2 -14.2,4580.4 -1341.4,1503.2",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15102.5,7262.9 c -267.5,0 -517.3,104.1 -682.5,288.2 l 31.6,28.4 c 176.8,-197 456.3,-298.1 747.3,-269.5 311.9,30.3 584.4,204.7 747.8,478.6 l 36.5,-21.8 c -170.4,-285.6 -454.7,-467.5 -780.2,-499.1 -33.7,-3.2 -67.3,-4.8 -100.5,-4.8",
    style: {
      fill: "#c5c5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15286.2,7839.3 c -282.9,-136.8 -630.4,-1.7 -772.7,300.7 l -48,102.4 -486.8,1034.3 -297.7,633.3 1438.7,695.4 626.5,-1331.2 c 257.4,-547.6 52.2,-1187.3 -460,-1434.9",
    style: {
      fill: "#ffbc96",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15256.9,9543.9 c -126.6,-616.8 -443.1,-1039.4 -791.4,-1301.5 l -486.8,1034.3 1278.2,267.2",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15425.6,10315.7 c 0,-744.9 -420,-1255.4 -952.6,-1518.6 -548.2,-270.9 -1120.6,769.8 -1394,1465.5 -283.8,722.1 497.4,1263.6 1151.5,1263.6 654,0 1195.1,-465.7 1195.1,-1210.5",
    style: {
      fill: "#ffbc96",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15455.2,10740.4 c -63.7,764.6 -219.1,1487.4 -927.4,1302.6 -269,375.2 -1394.6,368.2 -1670.7,-523.8 -178.1,-575.5 -750.4,-856.6 -750.4,-856.6 686.7,-361.1 1319.7,-225.9 2201.7,446 276.1,-403.6 1061.9,-431.9 1061.9,-431.9 l 84.9,63.7",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15675.1,10380.7 c -31,-241.4 -209.1,-417.5 -397.8,-393.3 -188.8,24.2 -316.6,239.5 -285.7,480.9 31,241.5 209.1,417.5 397.8,393.3 188.7,-24.2 316.6,-239.5 285.7,-480.9",
    style: {
      fill: "#ffbc96",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15402,10606.9 c -45.7,-37.7 -60.7,-88.8 -60.3,-143.4 0.4,-27.1 4.6,-54.5 12.5,-80.7 8.3,-26.1 19.5,-50.7 38.3,-72.4 l -12.6,-21.5 c -35,11.5 -61.1,41 -77.2,72.1 -16.4,31.5 -24.4,66.8 -24.4,102.3 0.3,35.4 8.2,72.1 28,103.4 19.1,31.5 51,55.8 85.3,62.9 l 10.4,-22.7",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14315,10153.1 c 4.4,-66.4 -40,-123.3 -99.2,-127.2 -59.2,-4 -110.7,46.6 -115.1,112.9 -4.4,66.4 40,123.3 99.1,127.2 59.2,4 110.8,-46.6 115.2,-112.9",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13735.2,9965.5 c 21.8,-56.2 -1.3,-117.5 -51.5,-137 -50.2,-19.4 -108.5,10.5 -130.3,66.7 -21.7,56.3 1.3,117.6 51.5,137.1 50.2,19.4 108.5,-10.5 130.3,-66.8",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14499,10456.6 c 2.2,-33.7 -176.7,-22.9 -253.5,-39.1 -65.7,-13.8 -165.6,-77.8 -210.6,-14 -40.7,57.6 61.4,122.9 187.9,131.3 126.6,8.4 273.9,-44.5 276.2,-78.2",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13346.1,10086.4 c 20.1,-27.5 111.4,67.3 163.9,91.7 44.8,20.8 140.1,18.7 124.4,90.7 -14.1,64.9 -111.5,67 -186.3,12.5 -74.7,-54.5 -122.1,-167.3 -102,-194.9",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14062.2,9328.4 c 41,49.3 99.4,81.2 158.7,101.2 59.8,19.6 121.4,28.2 183.5,23.6 l 4.6,-24.4 c -56.4,-26.8 -113.5,-41.7 -168.5,-59.5 -55.5,-17.2 -107.6,-37.6 -163.3,-60.8 l -15,19.9",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13901.2,9861.9 c 3.1,-46.2 -3.7,-95.5 -27.6,-140.5 -11.5,-22.5 -28.1,-42.8 -44.8,-59.7 -16.5,-16.9 -33.3,-31 -37.2,-41.1 -1.3,-5.2 -3.6,-9.2 -2.4,-16.8 -0.3,-4.6 1,-4.9 0.7,-5.6 0.2,-1.1 2,-2.7 3.1,-4.7 7.8,-8.9 26.6,-18 45.3,-24.9 38.6,-13.7 82.3,-23 125.4,-33.2 l -0.6,-24.9 c -46.4,-6.3 -92.5,-6 -140.3,4.4 -23.9,5.9 -48.6,12.8 -73.8,34.7 -5.8,6.5 -12.1,13.5 -16.1,22.6 -4.1,9.8 -6.7,20.1 -6.6,26.9 -2.3,14.7 0.8,33.4 8,48.8 16.5,30.3 37.2,43.7 52.4,57.9 15.9,13.8 28.8,27.9 40.4,43.8 23,31.9 37.4,72.1 49.3,114.8 l 24.8,-2.5",
    style: {
      fill: "#d28572",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14788.2,9700.7 c -141.8,0 -261.3,110.1 -270.8,253.7 -9.9,149.7 103.4,279.1 253.1,289 6.1,0.5 12.2,0.7 18.2,0.7 141.9,0 261.3,-110.2 270.8,-253.7 10,-149.7 -103.3,-279.2 -253,-289.1 -6.2,-0.4 -12.2,-0.6 -18.3,-0.6",
    style: {
      fill: "#ffa988",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18740.8,7434.1 c -419.7,882.6 -1285.8,1467.1 -2261.5,1526.6 l -199.2,12.3 1469.3,-3345.8 1608.3,597 -616.9,1209.9",
    style: {
      fill: "#3335cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13607.5,9614.7 c -15.9,244.3 26.6,817.7 -122.1,754 -148.7,-63.7 -185.8,-891.9 -185.8,-891.9 0,0 -21.3,1380.4 -180.6,1316.7 -159.3,-63.7 -159.3,-1061.9 -509.7,-2123.8 L 10641.2,4513.3 c -236.7,-500 61.5,-1089.1 604.6,-1194.2 398.4,-77.1 795.4,139.1 946.9,515.6 509.8,1266.6 1446,3999.9 1536.9,4532.3 74.4,435.4 55.2,623.7 26.4,735.6 -47.4,185 -136.1,321.6 -148.5,512.1",
    style: {
      fill: "#ffbc96",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12621.7,8761.6 c 60.2,163.7 99.6,334.9 136.2,505.9 36.2,171.3 66.5,343.8 97.7,516.3 l 92.3,518 c 16.3,86.3 33.1,172.6 53.3,258.5 10.2,43 21.1,85.8 34.7,128.5 7,21.3 14.5,42.6 24.2,63.8 4.8,10.5 10.5,21.2 17.6,31.8 7.7,10 15.9,22.7 36.6,29.1 l -1.6,-0.4 c 6.1,1.2 12.7,1.9 19,2 5.9,-0.9 11.7,-3.2 17.4,-5.4 8.9,-5.3 17.5,-12.2 22.2,-18.9 11.6,-13.7 18,-27.5 24.4,-41.4 12.2,-27.7 21,-55.6 28.3,-83.6 14.9,-56 25.3,-112.3 34.4,-168.7 17.7,-112.7 29.9,-225.9 39.3,-339.2 18.4,-226.7 28.2,-453.8 26,-681.4 l -48.3,1 c 5.3,128.5 15,256.1 29.5,383.7 15.5,127.5 33.3,255.1 73.4,380.1 11,31.1 23,62.1 41.5,91.8 9.7,14.6 20.6,29.4 36.8,41.4 15.3,12.9 39.2,19.1 61,16.1 5.1,-1.2 10,-3 14.9,-4.7 5.1,-2.2 9.2,-2.1 15.6,-7.8 3,-2.3 5.8,-4.8 8.4,-7.4 2.3,-2.5 3.1,-4.5 4.6,-6.8 2.6,-4.3 6,-9.1 7.5,-13.2 7.5,-16.8 12.4,-33 16.5,-49.1 8.3,-32.3 13.1,-64.3 17.8,-96.4 16.6,-128.4 21,-256.8 19.9,-385.2 -0.4,-64.7 -4.5,-127.5 1.1,-189.7 5,-62.4 16.4,-124.3 32.5,-185.1 16.3,-60.9 36.8,-120.8 59.3,-180.2 23,-58.8 46,-121.1 58.9,-184.5 27.4,-127 30.4,-257.6 18.6,-385.6 -11.8,-128.1 -36.8,-254.4 -70.3,-378.1 l -18.4,4.8 c 30.9,123.4 53.3,249 62.7,375.4 9.2,126.2 3.7,253.8 -25,376.2 -13.9,61.6 -35.1,119.6 -59.1,179.4 -23.1,59.9 -44.5,120.8 -61.5,183.2 -17,62.5 -29.2,126.5 -34.9,191.4 -6.2,65.1 -2.4,130.2 -2.5,193.1 0.3,126.9 -4.9,254.3 -21.9,379.2 -4.7,31 -9.6,62.2 -17.5,91.7 -3.8,14.7 -8.4,29.1 -14,41.5 -1.3,3.4 -3,4.9 -4.3,7.5 -1.6,3.4 -2.7,3.6 -2.7,3.6 1.2,0.8 -3.4,1.6 -5.6,2.5 -2.6,0.7 -5.2,2 -7.8,2.7 -18.8,3 -39.2,-13.6 -54.4,-38.8 -15.2,-24.7 -26.4,-53.6 -36.5,-82.7 -37.3,-118.7 -54.6,-245.6 -69,-371.4 -13.6,-126.1 -22.4,-253.5 -26.8,-380.1 l -48.3,1.1 c 2.1,225.6 -5.3,451.9 -22.6,677.1 -8.7,112.6 -20.1,225 -37,336.3 -8.5,55.5 -18.5,110.9 -32.5,164.5 -6.8,26.9 -15.1,53.2 -25.5,77.4 -5.2,11.8 -11.3,23.9 -18.2,31.8 -3.2,5 -6.8,6.5 -9.3,8.8 -1.1,-0.1 -1.9,0.7 -2.8,1.1 -0.7,-0.6 -1.2,-0.6 -2.2,-0.1 l -1.5,-0.5 c -0.8,0.1 -7.7,-5 -12.6,-12.6 -5.1,-7.6 -10,-16.2 -14.2,-25.6 -8.7,-18.6 -16,-38.7 -22.7,-59 -13.3,-40.8 -24.3,-82.9 -34.6,-125.2 -20.4,-84.7 -37.7,-170.5 -54.4,-256.4 l -95.3,-517.2 c -31.4,-172.6 -65.8,-344.8 -104.7,-516 -39.8,-171 -82.1,-342.1 -145.9,-506.8 l -17.7,6.9",
    style: {
      fill: "#d28572",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20126.8,3889.4 c -7.3,-489.4 -220.5,-831.3 -487.7,-1028.4 l -542.4,8.5 -134.2,2.2 h -3 l -637.6,1451.4 -1.2,3.4 -571.3,1300.6 1608.1,597.2 600.2,-1473.1 c 123.2,-325.8 172.9,-612.9 169.1,-861.8",
    style: {
      fill: "#ffbc96",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19681.6,4475.1 -4221.6,-472.3 -549.3,177.5 c -248.6,80.3 -521,30.9 -725.1,-132.2 -479,-382.6 -1257.8,-1087.8 -1056,-1144.5 339.9,-95.6 783.7,83.2 1182.1,183.3 220,55.2 452.5,29.1 654.5,-74.3 l 276.2,-141.5 4205.6,0.6 233.6,1603.4",
    style: {
      fill: "#ffbc96",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13230.2,2978.3 c 113.9,66.6 229.6,129.9 345.6,192.4 115.7,63.1 233.5,122.3 350.1,183.6 57.5,30.2 119.1,61.2 183.3,83.5 64.3,22 130.7,38.1 198.1,45.6 67.4,7.5 135.3,8.3 202.5,2.3 66.9,-7.4 133.3,-20.4 196.5,-42.1 l -6.5,-24.1 c -63.9,12.5 -128.3,21 -192.8,21.7 -64.4,2.1 -128.7,-2.2 -191.9,-12.9 -63.1,-10.7 -125.2,-26.6 -184.9,-49.1 -60.4,-21.1 -116,-51.2 -175.6,-81.1 -118.2,-58.4 -235.3,-118.8 -354.4,-175.4 -118.7,-57.2 -237.8,-113.5 -358.7,-166.6 l -11.3,22.2",
    style: {
      fill: "#d28572",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13291.6,3189.2 c 76.7,72.6 156.9,140.8 238.7,207.1 81.6,66.7 165.7,130.3 251.7,191.4 86.6,60.4 174.2,119.6 267.4,170.9 93.5,49 188.7,102.6 300.4,113 l 2.1,-24.8 c -48.3,-12.7 -95.4,-31.5 -140.3,-57.6 -45.9,-23 -89.9,-51 -133.8,-78.5 -87.8,-55.5 -173.5,-115.3 -259.2,-174.8 -85.8,-59.7 -170.1,-121.8 -255.6,-182.3 -85,-61.2 -169.6,-123.2 -255.5,-183.6 l -15.9,19.2",
    style: {
      fill: "#d28572",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18316.1,4294.6 -1.6,63.7 566.4,14.2 1.5,-63.7 -566.3,-14.2",
    style: {
      fill: "#d28572",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17730.4,5617.8 -411.1,837.2 38.1,18.8 411.1,-837.3 -38.1,-18.7",
    style: {
      fill: "#ebebff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19639.1,2861 -488.5,7.7 -53.9,0.8 -0.4,2.2 v 0 h 351.7 l 144.9,994.8 c 93.4,36.5 194.9,56.4 301.1,56.4 80.7,0 158.9,-11.4 232.8,-33.5 -7.3,-489.4 -220.5,-831.3 -487.7,-1028.4",
    style: {
      fill: "#ffa988",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19096.3,2871.7 c -20,70.9 -30.6,145.6 -30.6,223 0,351.2 218.3,651.1 527.1,771.7 0.1,0.1 0.1,0.1 0.1,0.1 L 19448,2871.7 h -351.7",
    style: {
      fill: "#ffa988",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13402.2,2874.2 h -2421.1 v 509.7 h 2421.1 v -509.7",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11802.3,2874.2 H 7958.16 L 6853.78,6718.3 h 3844.12 l 1104.4,-3844.1",
    style: {
      fill: "#ebebff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7942.85,2869.8 6832.64,6734.2 h 1189.24 v -31.9 H 6874.94 l 1098.54,-3823.7 -30.63,-8.8",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11390.5,4279.5 -704.6,2422.8 H 8913.89 v 31.9 h 1795.91 l 711.3,-2445.8 -30.6,-8.9",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11866,16092.4 c 0,-176 -142.7,-318.6 -318.6,-318.6 -175.9,0 -318.5,142.6 -318.5,318.6 0,175.9 142.6,318.5 318.5,318.5 175.9,0 318.6,-142.6 318.6,-318.5",
    style: {
      fill: "#ebebff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5204.3,8489.1 c 0,-226.7 -183.84,-410.6 -410.61,-410.6 -226.77,0 -410.6,183.9 -410.6,410.6 0,226.8 183.83,410.6 410.6,410.6 226.77,0 410.61,-183.8 410.61,-410.6",
    style: {
      fill: "#ebebff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25224.8,7682.1 c 0,-176 -142.7,-318.6 -318.6,-318.6 -175.9,0 -318.6,142.6 -318.6,318.6 0,175.9 142.7,318.5 318.6,318.5 175.9,0 318.6,-142.6 318.6,-318.5",
    style: {
      fill: "#ebebff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24319.5,8470.6 -15.4,39.6 c 51.8,20.1 106.3,31.9 162.1,35.2 l 2.4,-42.5 c -51.3,-2.9 -101.5,-13.8 -149.1,-32.3 z m 441.2,-42.6 c -43.3,27.4 -90.5,47.7 -140.1,60.4 l 10.5,41.1 c 53.9,-13.8 105.2,-35.8 152.3,-65.6 z m -675.9,-147 -35.4,23.3 c 30.6,46.5 68,87.8 111.3,122.8 l 26.7,-33 c -39.9,-32.2 -74.4,-70.3 -102.6,-113.1 z m 870.1,-83.8 c -19.4,47.3 -46,91.2 -79,130.5 l 32.5,27.3 c 35.9,-42.7 64.8,-90.3 85.8,-141.7 z m -993.1,-208.5 c -0.3,6.9 -0.4,14 -0.5,21 0,48.9 6.6,97.2 19.5,143.7 l 40.9,-11.3 c -11.9,-42.8 -17.9,-87.3 -17.9,-132.3 0.1,-6.4 0.2,-12.9 0.4,-19.4 z m 1046.9,-142.7 -40.5,13 c 15.6,48.6 23.5,99.4 23.5,150.8 0,13.1 -0.5,26.1 -1.5,38.8 l 42.3,3.4 c 1.1,-14 1.7,-28.1 1.7,-42.2 0,-55.9 -8.6,-111 -25.5,-163.8 z m -934.8,-164.9 c -34.2,44 -61.2,92.8 -80.3,145 l 39.9,14.6 c 17.6,-48.1 42.4,-93 73.9,-133.6 z m 744.3,-101.5 -25.4,34 c 41.1,30.7 77.1,67.4 106.9,109 l 34.5,-24.7 c -32.3,-45.2 -71.3,-85 -116,-118.3 z m -474.1,-83.9 c -53.3,16 -103.6,40 -149.6,71.6 l 24.1,35 c 42.3,-29 88.6,-51.2 137.7,-65.9 z m 164.2,-22.2 -0.8,42.5 c 51.5,1 102,9.9 150.3,26.4 l 13.8,-40.2 c -52.5,-17.9 -107.4,-27.6 -163.3,-28.7",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17366.6,15582.7 c -105.3,0 -191.1,-85.8 -191.1,-191.2 0,-105.4 85.8,-191.1 191.1,-191.1 105.4,0 191.2,85.7 191.2,191.1 0,105.4 -85.8,191.2 -191.2,191.2 z m 0,-424.8 c -128.8,0 -233.6,104.8 -233.6,233.6 0,128.8 104.8,233.6 233.6,233.6 128.9,0 233.7,-104.8 233.7,-233.6 0,-128.8 -104.8,-233.6 -233.7,-233.6",
    style: {
      fill: "#9192ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25493.8,2843.4 H 4567.15 v 63.7 H 25493.8 v -63.7",
    style: {
      fill: "#1b1b43",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestForQuoteConfirmationError);
export default __webpack_public_path__ + "static/media/requestForQuoteConfirmationError.3352cf9949efa88986dcf0c0ce8491c4.svg";
export { ForwardRef as ReactComponent };